import { useMemo } from 'react';
import { createAccommodationOptions, createAllowanceOptions, createShowDatesOptions, createHoursPerDayOptions, createServiceOptions } from '../constants/itemDetails.constants';

interface UseDropdownOptionsProps {
  t: any;
  articles: any[];
}

export const useDropdownOptions = ({ t, articles }: UseDropdownOptionsProps) => {
  
  const accommodationOptions = useMemo(() => createAccommodationOptions(t), [t]);
  const allowanceOptions = useMemo(() => createAllowanceOptions(t), [t]);
  const showDatesOptions = useMemo(() => createShowDatesOptions(t), [t]);
  const hoursPerDayOptions = useMemo(() => createHoursPerDayOptions(t), [t]);
  const serviceOptions = useMemo(() => createServiceOptions(articles), [articles]);

  return {
    accommodationOptions,
    allowanceOptions,
    showDatesOptions,
    hoursPerDayOptions,
    serviceOptions,
  };
};
